
import React from "react";
import "./motionSurface.css";

function ResultReveal({ children, delay = 0, style = {} }) {
  return (
    <div
      className="hookora-result-reveal"
      style={{
        animationDelay: `${delay}ms`,
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export default ResultReveal;
